import React from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import IconButton from "@mui/material/IconButton";
import DehazeIcon from "@mui/icons-material/Dehaze";
import AuthService from "../../common/AuthService";
import NoticeIcon from "./NoticeIcon";
import LocalesMenu from "./LocalesMenu";
import AccountIcon from "./AccountIcon";
import { INoticesRow } from "../../webapi/service/getNotices";

export interface IProps extends WithTranslation {
  /**
   * 認証サービス
   */
  authService?: AuthService;
  /**
   * ナビバーが開いている場合はtrue
   */
  naviOpen: boolean;
  /**
   * ナビバーの開閉を切り替える場合に呼び出します
   * @param open - 開く場合はtrue
   */
  onNaviOpen: (open: boolean) => void;
  /**
   * トップページを表示する場合に呼び出します
   */
  onTop: () => void;
  /**
   * 通知件数
   */
  noticeCount: number;
  /**
   * 通知項目が選択された場合に呼び出されます
   */
  onNotice: (data: INoticesRow | undefined) => void;
  /**
   * ログインユーザー名
   */
  name?: string;
  /**
   * ログアウトが押された場合に呼び出されます
   */
  onLogout?: () => void;
  /**
   * ライセンスボタンが押された場合に呼び出されます
   */
  onLicense?: () => void;
  /**
   * 通信エラーが発生した場合に呼び出します
   * @param id - メッセージID
   * @param status - httpステータスコード
   */
  onCommunicationError: (
    id: string | undefined,
    status: number | undefined
  ) => void;
}

class Header extends React.Component<IProps> {
  constructor(props: IProps) {
    super(props);

    this.handleClickNaviOpen = this.handleClickNaviOpen.bind(this);
  }

  handleClickNaviOpen() {
    this.props.onNaviOpen(this.props.naviOpen ? false : true);
  }

  render() {
    const {
      authService,
      onTop,
      noticeCount,
      onNotice,
      name,
      onLogout,
      onLicense,
      onCommunicationError,
      t,
    } = this.props;
    const account = authService ? (
      <AccountIcon
        authService={authService}
        name={name}
        onLogout={onLogout}
        onLicense={onLicense}
        onCommunicationError={onCommunicationError}
      />
    ) : (
      ""
    );
    return (
      <header className="header">
        <IconButton
          size="large"
          color="inherit"
          onClick={this.handleClickNaviOpen}
        >
          <DehazeIcon />
        </IconButton>
        <label onClick={onTop}>{t("header_product_name")}</label>
        <NoticeIcon
          authService={authService}
          noticeCount={noticeCount}
          onNotice={onNotice}
          onCommunicationError={onCommunicationError}
        />
        <LocalesMenu />
        {account}
      </header>
    );
  }
}

export default withTranslation()(Header);
